import type OptionAlternateTextPlatformStyles from './types';

const optionAlternateTextPlatformStyles: OptionAlternateTextPlatformStyles = {};

export default optionAlternateTextPlatformStyles;
